export const EN_STRINGS: { [key: string]: string } = {
  access_error_main: 'An error occurred and this page cannot be displayed.',
  access_error_title: 'Access Error',
  all_rights_reserved: 'All Rights Reserved.',
  apologize_for_inconvenience: 'We apologize for any inconvenience.',
  assistance_text: 'For assistance, contact your system administrator.',
  backend_error_hint: 'If the issue persists please contact your helpdesk team.',
  backend_error_main2: 'Please navigate to your dashboard and try again.',
  backend_error_main:
    'There was a problem processing your request. We apologize for the inconvenience.',
  backend_error_title: 'Oops!',
  forbidden_error_main2: 'Access is controlled by your administrator.',
  forbidden_error_main: 'You do not have permission to access this page.',
  forbidden_error_title: 'Insufficient Permissions',
  logout_msg_1: 'You have successfully logged out or your Store session has expired.',
  logout_msg_2: 'Click below to return to the ${ input } portal.',
  logout_title: 'You Have Been Logged Out',
  page_not_found: 'Page Not Found',
  page_not_found_txt: 'The page that you are attempting to access cannot be found.',
  privacy_notice: 'Privacy Notice',
  request_error_main: 'The server encountered a problem while trying to display this page.',
  request_error_title: 'Unable to Display Page',
  resolving_error_txt: 'We are working to resolve this issue and apologize for any inconvenience.',
  resource_error_main: 'The resource that you are attempting to access cannot be found.',
  resource_error_title: 'Resource Not Found',
  return_to_dashboard: 'Return to Dashboard',
  return_to_login: 'Return to Login Page',
  return_to_portal: 'Return to Portal',
  service_error_main: 'The service that you are attempting to access is currently unavailable.',
  service_error_title: 'Service Unavailable',
  unauthorized_error_main2: 'Access is controlled by your administrator.',
  unauthorized_error_main: 'You are either not authenticated or your authentication is invalid.',
  unauthorized_error_title: 'Invalid Authentication'
};
